import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { MetaOAuthCallbackPage, type MetaOAuthCallbackParams } from '@/features/integrations/facebook-instagram/meta-oauth-callback-page';
import { formatDocumentTitle } from '@/lib/document-title';

const readParam = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

/**
 * Facebook Login redirect target for Comment → DM. Must match the API's `META_OAUTH_REDIRECT_URL` exactly
 * (e.g. `https://app.example.com/meta/comment-to-dm/callback`) and be listed in the Meta app's
 * "Valid OAuth Redirect URIs".
 */
export const Route = createFileRoute('/_auth/meta/comment-to-dm/callback')({
  validateSearch: (search: Record<string, unknown>): MetaOAuthCallbackParams => ({
    code: readParam(search.code),
    state: readParam(search.state),
    error: readParam(search.error),
  }),
  component: MetaOAuthCallbackRoute,
});

function MetaOAuthCallbackRoute() {
  const { code, state, error } = Route.useSearch();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Connecting Facebook')}</title>
      </Helmet>
      <MetaOAuthCallbackPage code={code} state={state} error={error} />
    </>
  );
}
